import Lookup from 'src/componentes/select2';

const TipoItem = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/TipoPacoteContaLookup"
      {...props}
    />
  );
};

export default TipoItem;
